import { SelectPersonField } from 'modules/components/layer04';
import React from 'react';
import * as ds from './dataService';
import {
  BasicFormModalLayout,
  InformationModalLayout
} from 'modules/components/layer13';
import { FormBaseLayout } from 'modules/components/layer10';


export type SaveSuperAdminModalProps = {
  isVisible: boolean;
  handleClose: () => void;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: SaveSuperAdminModalProps) => {
  const form = ds.useFormState();
  const [
    fnSaveSuper,
    { loading }
  ] = ds.useSaveSuperAdmin();

  return (
    <BasicFormModalLayout.FC
      id=''
      handleClose={props.handleClose}
      isVisible={props.isVisible}
      title='Add SuperAdmin'
    >
      <FormBaseLayout.FC
        ignoreCancel={true}
        handleCancel={() => {
          props.handleClose();
        }}
        isLoading={loading}
        successButtonText='Upgrade User'
        handleSubmit={async () => {
          await fnSaveSuper(form.formState.selection?.id ?? '');
          props.handleClose();
        }}
      >

        <SelectPersonField.FC
          fieldName='selection'
          freeTextField='freeText'
          form={form}
        />
      </FormBaseLayout.FC>
    </BasicFormModalLayout.FC>
  );
};
